import { css, cx } from '@/styled-system/css';

interface ListingCardContainerOptions {
  listingViewed?: boolean;
  isCarouselCard?: boolean;
  shouldUseNewLayout?: boolean;
}
interface HeroPhotoContainerOptions {
  isLoading?: boolean;
  isCarouselCard?: boolean;
}

export const getListingCardContainerCX = (options: ListingCardContainerOptions) =>
  css({
    bg: options?.listingViewed ? 'hpxGrey100' : 'hpxWhite',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(209, 209, 213, 0.5)',
    borderRadius: '8px',
    boxShadow: {
      base: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
      _hover: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
      _focus: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
    },
    cursor: 'pointer',
    height: options?.shouldUseNewLayout ? '354px' : '334px', // +20px for 5-line layout
    marginTop: '0',
    marginRight: 'auto',
    marginBottom: '0',
    marginLeft: 'auto',
    width: {
      base: options?.isCarouselCard ? '286px' : '100%',
      listingCardWidth: options?.isCarouselCard ? '300px' : '404px',
    },
  });

/** Image */
export const getHeroPhotoContainerCX = (options?: HeroPhotoContainerOptions) =>
  css({
    height: '224px',
    position: 'relative',
    width: {
      base: '100%',
      listingCardWidth: options?.isCarouselCard ? '298px' : '402px',
    },
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    animation: options?.isLoading ? 'shimmering' : '',
    bgGradient: options?.isLoading ? 'heroPhotoContainerBgGradient' : '',
    backgroundSize: options?.isLoading ? '1000px 100%' : '',
    // bg overrides bgGradient
    bg: options?.isLoading ? '' : 'hpxGrey400',
  });

/** Listing Card Badges */

export const badgeContainerCX = css({
  position: 'absolute',
  display: 'flex',
  flexDir: 'row',
  gap: '4px',
  top: '16px',
  left: '16px',
});

export const badgeOutlineCX = css({
  bgColor: 'hpxWhite',
  borderRadius: '50%',
  borderWidth: '0.75px',
  borderStyle: 'solid',
  borderColor: '#949494',
  height: '26px',
  width: '26px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const getInfoBadgeCX = (type?: 'upsell' | 'housing' | 'specialOfferLabel') =>
  css({
    backgroundColor:
      type === 'upsell'
        ? '#8B6090'
        : type === 'housing'
          ? 'hpPurple500'
          : type === 'specialOfferLabel'
            ? 'hpxYellow500'
            : '#49284e',
    color: type === 'specialOfferLabel' ? 'hpxBlue700' : 'hpxWhite',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '600',
    paddingTop: '2px',
    paddingRight: '8px',
    paddingBottom: '1px',
    paddingLeft: '8px',
    borderRadius: '48px',
  });

// /** Listing Details */

export const infoBadgesCX = css({
  display: 'flex',
  flexDir: 'row',
  gap: '4px',
  position: 'absolute',
  right: '16px',
  top: '10px',
});

export const detailedInfoContainerCX = css({
  height: '100px',
  paddingTop: '12px',
  paddingRight: '16px',
  paddingBottom: '14px',
  paddingLeft: '16px',
  position: 'relative',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'rgba(209, 209, 213, 0.5)',
});

export const getDetailedInfoContainerCX = (options?: { shouldUseNewLayout?: boolean }) =>
  css({
    height: options?.shouldUseNewLayout ? '120px' : '100px', // +20px for 5-line layout
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '14px',
    paddingLeft: '16px',
    position: 'relative',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'rgba(209, 209, 213, 0.5)',
  });

export const detailedInfoTextCX = css({
  textAlign: 'left',
  color: '#6e6e6e',
  fontSize: '14px',
  lineHeight: '20px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

export const listingCardAnchorCX = css({
  color: '#6e6e6e',
  textDecoration: 'none',
  fontWeight: 'normal',
});

export const priceTextCX = css({
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: '700',
  display: 'inline-block',
  color: 'hpxBlue700',
});

/** Skeleton Components */

export const skeletonWrapperCX = css({
  maxWidth: '402px',
  lg: { width: '50px' },
});

export const priceSkeletonCX = cx(
  priceTextCX,
  css({
    backgroundColor: '#f2f2f2',
    height: '20px',
    width: '160px',
  }),
);

export const detailedInfoTextSkeletonCX = css({
  backgroundColor: 'hpxGrey100',
  height: '14px',
  marginBottom: '6px',
  width: '260px',
});
